import { CLIENT, DISCRETIONARY_HOURS } from '../constants';
import { FetchAPI } from '../Main/fetchAPI';
import { UserSessionAllocationMonthlyDetailsProperties } from '../userAPIProperties';

export interface AdminHourServiceCode {
	code: string;
	id: string;
	isActive: boolean;
	name: string;
}

export const AdminHours = {
	saveServiceCode: (data: Omit<AdminHourServiceCode, 'id'>, id?: string) =>
		id
			? FetchAPI.putJson({ urlStr: `${CLIENT}/adp-rate-mappings/service-codes/${id}`, data })
			: FetchAPI.postJson({ urlStr: `${CLIENT}/adp-rate-mappings/service-codes`, data }),
	getUsage: (userId: string, date: string): Promise<UserSessionAllocationMonthlyDetailsProperties | null> =>
		FetchAPI.getJson({ urlStr: `${DISCRETIONARY_HOURS}/usage/${userId}?date=${date}` }).then((response) => {
			if (response?.error) throw response.error;

			return response?.userId === userId ? response : null;
		}),
	getServiceCodes: (includeInactive = false): Promise<AdminHourServiceCode[]> =>
		FetchAPI.getJson({ urlStr: `${CLIENT}/adp-rate-mappings/service-codes?includeInactive=${includeInactive}` }).then(
			(response) => {
				if (response?.error) throw response.error;

				return response || [];
			},
		),
};
